import { TFunction } from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { createInvalidCharText } from '../../../lib/message-validator';
import { ReportError } from '../../../models/report/ReportError';
import { CommonDialog } from '../dialog/CommonDialog';

interface ReportFailedProps {
  errorType: ReportError['type'];
  invalidChar?: string[];
}

export const ReportFailed: React.FC<ReportFailedProps> = ({ errorType, invalidChar }) => {
  const { t } = useTranslation(['chat', 'translation']);
  const title = t('error_send_failed');
  const description = getText(t, errorType, invalidChar);

  return <CommonDialog title={title} description={errorType && description} />;
};

// helper function
function getText(t: TFunction, errorType: ReportError['type'], invalidChars?: string[]) {
  if (invalidChars) {
    const chars = createInvalidCharText(invalidChars);
    return t('error_invalid_char', { chars });
  } else {
    switch (errorType) {
      case 'unstable-network':
        return t('translation:error_unstable_network');
      case 'unknown':
      default:
        return t('translation:error_unknown');
    }
  }
}
